import { action } from '@ember/object';
import Component from '@glimmer/component';

import didInsert from 'webapp/modifiers/did-insert';
import CommonUiIcon from 'webapp/components/common/ui-icon';

export enum ContentStyle {
	DEFAULT = 'default',
	BEHIND = 'behind',
}

export interface Args {
	images: string[];
	options?: Record<string, unknown>; // To override predefinedOptions: https://kenwheeler.github.io/slick/
	contentStyle?: ContentStyle;
}

export default class CommonImageSliderComponent extends Component<Args> {
	get contentStyle() {
		return this.args.contentStyle || ContentStyle.DEFAULT;
	}

	@action
	setupSlider(node: HTMLElement) {
		const sliderMainContentElement = node.querySelector('.image-slider__content');

		if (!sliderMainContentElement) {
			return;
		}

		const prevArrow = node.querySelector('.slick-arrow--left');
		const nextArrow = node.querySelector('.slick-arrow--right');

		const predefinedOptions = {
			speed: 500,
			centerMode: true,
			centerPadding: '0',
			infinite: true,
			prevArrow: prevArrow,
			nextArrow: nextArrow,
			appendArrows: node,
			variableWidth: true,
		};

		const options = { ...predefinedOptions, ...(this.args.options || {}) };

		$(sliderMainContentElement).slick(options);
	}

	<template>
		<div
			class="image-slider image-slider--{{this.contentStyle}}"
			{{didInsert this.setupSlider}}
		>
			<div class="slick-arrow--left"><CommonUiIcon @name="ChevronLeft" @size="xs" /></div>
			<div class="slick-arrow--right"><CommonUiIcon @name="ChevronRight" @size="xs" /></div>
			<div class="image-slider__content">
				{{#each @images as |image|}}
					<div>
						<img src={{image}} alt="Slide" />
					</div>
				{{/each}}
			</div>
		</div>
	</template>
}
